import { API_USER_SERVICE } from "../config/Constants";
import { getRequest } from "./Rest";

export const getDashboardStats = async(warehouseId:number)=>{
    const path = `${API_USER_SERVICE}/orders/stats/warehouse-capacity?warehouseId=${warehouseId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return dataResponse;
}
export const getDashboardBuildingCapacity = async(warehouseId:number) =>{
    const path = `${API_USER_SERVICE}/orders/stats/building-capacity?warehouseId=${warehouseId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return dataResponse;
}
